export enum EDeviceEventType {
    AUTOMATION = 'automation',
    COMMAND = 'command',
    STATUS = 'status',
    DEBUG = 'debug',
}

export function getDeviceEventTypeLabel(type: EDeviceEventType): string {
    switch (type) {
        case EDeviceEventType.AUTOMATION:
            return 'Automation';
        case EDeviceEventType.DEBUG:
            return 'Debug';
        case EDeviceEventType.COMMAND:
            return 'Command';
        case EDeviceEventType.STATUS:
        default:
            return 'Status';
    }
}

export function getDeviceEventType(type: string): EDeviceEventType {
    switch (type?.toLowerCase()) {
        case 'automation':
            return EDeviceEventType.AUTOMATION;
        case 'debug':
            return EDeviceEventType.DEBUG;
        case 'command':
            return EDeviceEventType.COMMAND;
        case 'status':
        default:
            return EDeviceEventType.STATUS;
    }
}
